<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Historial de EDIS - {{ numeroContenedor }}</h3>
            </div>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Secuencia</th>
                        <th>Fecha</th>
                        <th>Path</th>
                        <th>Enviado</th>
                        <th>Usuario</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="edi in edis" :key="edi.id">
                        <td>
                            {{ edi.edi.secuencial }}
                        </td>
                        <td>
                            {{ edi.created_at }}
                        </td>
                        <td>
                            {{ edi.edi.path }}
                        </td>
                        <td>
                            {{ edi.edi.enviado }}
                        </td>
                        <td>
                            {{ edi.usuario != null?edi.usuario.nombre_usuario:'' }}
                        </td>
                        <td>
                            <button @click="descargar(edi)" class="btn-info btn--text"><i class="fa fa-download"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-buttons">
            <button @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        numeroContenedor: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            edis: []
        };
    },
    methods: {
        descargar: function (edi) {
            window.open(url + "/edis/" + edi.id, "_blank");
        }
    },
    mounted: function () {
        axios.get(url + '/' + this.numeroContenedor + '/historial').then(({data}) => {
            this.edis = data;
        }).catch(() => {
            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
        });
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/HistorialEdis.vue